import { render, staticRenderFns } from "./projectRD.vue?vue&type=template&id=bfd53244&"
import script from "./projectRD.vue?vue&type=script&lang=ts&"
export * from "./projectRD.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports